import { render, staticRenderFns } from "./StemdoersList.vue?vue&type=template&id=54fdd5b3&scoped=true"
import script from "./stemdoersList.ts?vue&type=script&lang=ts&external"
export * from "./stemdoersList.ts?vue&type=script&lang=ts&external"
import style0 from "./StemdoersList.vue?vue&type=style&index=0&id=54fdd5b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fdd5b3",
  null
  
)

export default component.exports